import React, { useEffect, useReducer, useState } from 'react';
import { useDispatch } from 'react-redux';
import { TIME_LIST } from '../../../../../constants/DashboardConst';
import CustomFormView from '../../../../../shared/custom-form-view/Custom-Form-View';
import CustomSelect from '../../../../../shared/form-controls/custom-select/Custom-Select';
import CustomTextField from '../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import {
  createRestaurantTables,
  updateRestaurantTables,
} from '../../../../../utils/dashboardAPIUtils';
import { formDataValidate } from '../../../../../utils/formUtils';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import { fetchRestaurantDashboardReservationDetails } from '../../../DashboardSlice';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const TableInfoCreate = (props) => {
  const { toggleDrawer, table, restaurantId, hotelId, showLoader = () => {} } = props;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [isTabInValid, setIsTabInValid] = useState(true);
  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    tableNumber: {
      value: '',
      fieldName: 'Table Number',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    capacity: {
      value: '',
      fieldName: 'Capacity',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    exposure: {
      value: '',
      fieldName: 'Exposure',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    duration: {
      value: '',
      fieldName: 'Slot Duration',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
  });

  useEffect(() => {
    if (table) {
      const currFields = { ...formData };
      for (let field in currFields) {
        currFields[field].value = table[field];
      }
      setFormData(currFields);
    }
  }, [table]);

  const validate = (tabValue, isUpdatedFields) => {
    const updatedFields = {};
    const currTabFromData = Object.fromEntries(
      Object.entries(formData).filter(([key, field]) => field.tab === tabValue),
    );
    const isValid = formDataValidate(
      currTabFromData,
      isUpdatedFields ? updatedFields : isUpdatedFields,
    );
    if (isUpdatedFields) setFormData(updatedFields);
    return isValid;
  };

  useEffect(() => {
    const isValidate = validate(0, false);
    setIsTabInValid(!isValidate);
  }, [formData]);

  const onCancel = () => {
    toggleDrawer('', false, '');
  };

  const handleSubmit = async (e) => {
    try {
      dispatch(stepUpLoaderCount());
      e.preventDefault();
      const lang = decryptLocalStorage('lang');
      const language = lang !== 'en' ? lang : '';
      if (!validate(0, true)) return false;
      setLoading(true);
      const payload = {
        tableNumber: Number(formData.tableNumber.value),
        capacity: formData.capacity.value,
        exposure: formData.exposure.value,
        duration: formData.duration.value,
        hotelId,
        restaurantId,
      };
      table
        ? await updateRestaurantTables(payload, language)
        : await createRestaurantTables(payload, language);
      dispatch(fetchRestaurantDashboardReservationDetails(restaurantId));
      notificationManager('success', `Table ${table ? 'updated' : 'created'} successfully`);
      setLoading(false);
      onCancel();
    } catch (error) {
      notificationManager(
        'danger',
        error?.graphQLErrors
          ? error?.graphQLErrors?.[0]?.message
          : `Error occurred while ${table ? 'updating' : 'creating'} the Table`,
      );
      setLoading(false);
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  return (
    <CustomFormView
      handleSubmit={handleSubmit}
      tabTitle={[]}
      onCancel={onCancel}
      tabValue={0}
      maxtab={0}
      isUpdate={table ? true : false}
      loading={loading}
      title={`${table ? 'Edit' : 'Add'} Table`}
      titleClass='col-md-11'
      isTabInValid={isTabInValid}
      tabClass=''
      cancelClass='col-md-1 '
    >
      <div className='col-md-12 mb-3'>
        <h4 className='tab-title'>Details</h4>
        <div className='row'>
          <div className='col-md-6 mb-3'>
            <CustomTextField
              item={formData.tableNumber}
              handleInputChange={(e) => {
                setFormData({ tableNumber: e });
              }}
              type='number'
            />
          </div>
          <div className='col-md-6 mb-3'>
            <CustomTextField
              item={formData.capacity}
              handleInputChange={(e) => {
                setFormData({ capacity: e });
              }}
              type='number'
            />
          </div>
        </div>
        <div className='row'>
          <div className='col-md-6 mb-3'>
            <CustomTextField
              item={formData.exposure}
              handleInputChange={(e) => {
                setFormData({ exposure: e });
              }}
            />
          </div>
          <div className='col-md-6 mb-3'>
            <CustomSelect
              valueField='id'
              labelField='name'
              item={formData.duration}
              handleInputChange={(e) => {
                setFormData({ duration: e });
              }}
              options={TIME_LIST}
              hideNullOption={true}
            />
          </div>
        </div>
      </div>
    </CustomFormView>
  );
};

export default TableInfoCreate;
